export default /*@ngInject*/ function ($scope) {
    return;
}
